import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { ImportHubComponent } from './import.hub.component';

// WS-6774. Everything this module used to register has been deleted: the AngularJS
// controllers and the template that were the old import page, which nothing routes to
// now that both applications open the rebuilt one.
//
// What remains is the one thing AngularJS still needs to know about: the rebuilt page
// is an Angular component, and the route that opens it is still an AngularJS state, so
// it has to be downgraded for the element to exist at runtime.
angular.module('app-lite.imports', [
  'app-lite.api',
  'app-lite.core',
  'app-lite.messages'
])
.directive('worImportHub', downgradeComponent({ component: ImportHubComponent }));
